import { api } from '../utils/jsonp.js'
import { setCookie, getCookie, removeCookie } from '../utils/cookie.js'
import { COOKIE_DOMAIN, DEFAULT_AVATAR } from '../utils/constants.js'

/**
 * 用户认证模块
 */
export class Auth {
  constructor(options = {}) {
    this.user = null
    this.isLoading = false
    this.onLoginSuccess = options.onLoginSuccess || (() => {})
    this.onLogout = options.onLogout || (() => {})
  }

  formatUserInfo(data) {
    return {
      userid: data.userid,
      username: data.username,
      userface: data.userface || DEFAULT_AVATAR,
      emailClass: data.emailClass,
      phoneClass: data.phoneClass,
      weixinClass: data.weixinClass,
      qqClass: data.qqClass,
      sinaClass: data.sinaClass,
      iscolumn: data.iscolumn,
      token: data.token,
      modifitime: data.modifitime
    }
  }

  async initUser() {
    this.isLoading = true

    try {
      const userCookie = getCookie('UserCookie')

      if (userCookie) {
        const verifyResult = await api.verifyExpiration(
          userCookie.userid,
          userCookie.modifitime,
          !!getCookie('EditPassword')
        )

        if (verifyResult.Islate) {
          this.user = this.formatUserInfo(userCookie)
          this.isLoading = false
          return
        } else {
          removeCookie('UserCookie')
          removeCookie('isLogin')
        }
      }

      const loginResult = await api.loginCheck()

      if (loginResult.status === 'ok') {
        setCookie('UserCookie', JSON.stringify(loginResult), {
          path: '/',
          domain: COOKIE_DOMAIN
        })
        this.user = this.formatUserInfo(loginResult)
      } else {
        removeCookie('UserCookie')
        removeCookie('isCheck')
        this.user = null
      }
    } catch (error) {
      console.error('[Auth] 初始化用户信息失败:', error)
      this.user = null
    } finally {
      this.isLoading = false
    }
  }

  async loginWithPassword(username, password, rememberMe = false) {
    this.isLoading = true

    try {
      const expiration = rememberMe ? 'Year' : 'None'

      if (rememberMe) {
        setCookie('isPersistent', 'Year', { path: '/', domain: COOKIE_DOMAIN })
      }

      const result = await api.userLogin(username, password, expiration)

      if (result.status === 'ok') {
        await new Promise(resolve => setTimeout(resolve, 500))
        await this.initUser()

        if (!this.user) {
          window.location.reload()
          return { success: true }
        }

        this.onLoginSuccess(this.user)
        return { success: true }
      } else {
        return { success: false, message: result.body || '登录失败' }
      }
    } catch (error) {
      console.error('[Auth] 登录请求异常:', error)
      return { success: false, message: '登录请求失败' }
    } finally {
      this.isLoading = false
    }
  }

  async loginWithSms(phone, code) {
    this.isLoading = true

    try {
      const result = await api.smsRegister(phone, code)

      if (result.repCode === 1) {
        await new Promise(resolve => setTimeout(resolve, 500))
        await this.initUser()

        if (!this.user) {
          window.location.reload()
          return { success: true }
        }

        this.onLoginSuccess(this.user)
        return { success: true }
      } else {
        return { success: false, message: result.repMsg || '验证码错误' }
      }
    } catch (error) {
      console.error('[Auth] 短信登录请求异常:', error)
      return { success: false, message: '登录请求失败' }
    } finally {
      this.isLoading = false
    }
  }

  async logout() {
    try {
      await api.userLogout()

      removeCookie('UserCookie')
      removeCookie('isLogin')
      removeCookie('isCheck')
      this.user = null

      this.onLogout()
      return { success: true }
    } catch (error) {
      console.error('[Auth] 登出请求异常:', error)
      removeCookie('UserCookie')
      removeCookie('isLogin')
      removeCookie('isCheck')
      this.user = null
      return { success: true }
    }
  }

  oauthLogin(type, returnUrl) {
    const currentUrl = returnUrl || window.location.href

    let authorizetype = type
    if (type === 'weixin') {
      const isWechat = navigator.userAgent.toLowerCase().match(/MicroMessenger/i)
      if (isWechat) {
        authorizetype = 'weixinmp'
      }
    }

    const url = `//i.gamersky.com/oauth/authorizelogin?authorizetype=${authorizetype}&returnUrl=${encodeURIComponent(currentUrl)}`
    window.location.href = url
  }
}